// src/components/support/SupportContent.jsx
import React, { useState, useMemo, useEffect } from "react";
import Branch from "./Branch";
import MediaModal from "./MediaModal";
import {
  getBrandThemeClasses,
  resolveBrandThemeId,
} from "../../utils/brandThemeClasses";

const SupportContent = ({ supportCategories = [], sidebarTitle = "Support" }) => {
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);

  // Ensure we always have a valid selected branch when categories change
  useEffect(() => {
    if (supportCategories && supportCategories.length > 0) {
      if (
        !selectedBranchId ||
        !supportCategories.find((b) => b.id === selectedBranchId)
      ) {
        setSelectedBranchId(supportCategories[0]?.id || null);
      }
    }
  }, [supportCategories, selectedBranchId]);

  const selectedBranch = useMemo(() => {
    if (!supportCategories || supportCategories.length === 0) return null;
    return (
      supportCategories.find((branch) => branch.id === selectedBranchId) ||
      supportCategories[0]
    );
  }, [selectedBranchId, supportCategories]);

  const selectedThemeId = resolveBrandThemeId(selectedBranch);
  const selectedThemeClasses = getBrandThemeClasses(selectedThemeId);

  const handleMediaClick = (media) => {
    setSelectedMedia(media);
  };

  const handleCloseModal = () => {
    setSelectedMedia(null);
  };

  return (
    <>
      {/* Main Content Section */}
      <section className="section-surface-mist w-full py-12 md:py-16 lg:py-20">
        <div
          className="container mx-auto flex flex-col gap-8 px-4 sm:px-6 lg:flex-row lg:gap-12 lg:px-8"
          data-product-theme={selectedThemeId}
        >
          {/* Left: Branch navigation (themed like products BrandSidebar) */}
          <aside className="lg:w-64 xl:w-72 lg:sticky lg:top-24 lg:self-start">
            <div className="product-panel-elevated backdrop-blur-md rounded-2xl p-4 shadow-xl md:p-5 lg:p-6">
              <h2 className="product-heading mb-4 text-lg font-bold md:mb-5 md:text-xl">
                {sidebarTitle}
              </h2>
              <div className="space-y-2">
                {supportCategories.map((branch) => {
                  const isActive = branch.id === selectedBranchId;
                  return (
                    <button
                      key={branch.id}
                      type="button"
                      onClick={() => setSelectedBranchId(branch.id)}
                      className={`w-full rounded-xl px-3 py-2 text-left text-sm transition-all duration-200 md:text-base ${
                        isActive
                          ? "product-sidebar-active"
                          : "product-sidebar-inactive"
                      }`}
                    >
                      {branch.title}
                    </button>
                  );
                })}
              </div>
            </div>
          </aside>

          {/* Right: Selected branch content */}
          <div className="min-w-0 flex-1">
            {selectedBranch && (
              <Branch
                branch={selectedBranch}
                index={0}
                themeId={selectedThemeId}
                themeClasses={selectedThemeClasses}
                onMediaClick={handleMediaClick}
              />
            )}
          </div>
        </div>
      </section>

      {/* Media Modal */}
      <MediaModal
        isOpen={!!selectedMedia}
        onClose={handleCloseModal}
        media={selectedMedia}
      />
    </>
  );
};

export default SupportContent;


